import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { setKey, session } from "../store/actions";
import { connect } from "react-redux";
import { swalDeleteForm, swalError, swalSmallForm, swalSuccess, swalInfo } from "../utils/swal";
import settingService from '../services/setting';
import Switch from "react-switch";

function ManageMaintenanceMode({
    session,
    setKey,
    ...props
}) {
    const { t } = useTranslation();
    const [showMaintenance, setShowMaintenance] = useState(true);
    const [announcement, setAnnouncement] = useState(``);

    useEffect(() => {
        settingService.get()
            .then(response => {
                if (response && response.data) {
                    setShowMaintenance(response.data.maintenanceMode);
                    setAnnouncement(response.data.maintenanceMessage);
                }
            });
    }, []);

    const handleOnChange = checked => {
        setShowMaintenance(checked);
        if (!checked)
            save(checked, ``);
    }

    const handleSave = () => {
        if (!announcement || announcement.length === 0)
            return swalInfo(t("maintenance_msg_required"));

        save(showMaintenance, announcement);
    }

    const save = (show, text) => {
        settingService.updateMaintenanceMode(session.token, show, text)
            .then(response => {
                swalSuccess(t("setting_updated"));
            });
    }

    return (
        <div className="container">
            <div className="row mt-10">
                <div className="col text-left">
                    <h3>{t("manage_maintenance_title")}</h3>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <p>{t("maintenance_desc")}</p>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <Switch onChange={handleOnChange} checked={showMaintenance} />
                    <br />
                    {!showMaintenance && <p style={{ color: 'green' }}>{t("maintenance_off_msg")}</p>}
                    {showMaintenance && <p style={{ color: 'red' }}>{t("maintenance_on_msg")}</p>}
                </div>
            </div>
            {
                showMaintenance &&
                <div className="row mt-10">
                    <div className="col-11">
                        <input
                            type="text"
                            className="form-control"
                            placeholder={t("maintenance_msg_placeholder")}
                            value={announcement}
                            onChange={e => setAnnouncement(e.target.value)}
                        />
                    </div>
                    <div className="col-1">
                        <button className="btn btn-light" onClick={handleSave}>{t("btn_save")}</button>
                    </div>
                </div>
            }
        </div>
    );
}

const mapStateToProps = store => ({
    session: store.session
});

const mapDispatchToProps = dispatch => ({
    setKey: (key, value) => dispatch(setKey(key, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageMaintenanceMode);